"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.meetingSchema = void 0;
const zod_1 = require("zod");
const account_short_1 = require("./account-short");
const lingo2_models_1 = require("lingo2-models");
const image_file_1 = require("./image-file");
const school_short_1 = require("./school-short");
const meeting_participant_1 = require("./meeting-participant");
const user_service_1 = require("./user-service");
const classroom_1 = require("./classroom");
const hash_1 = require("./hash");
// Схема для Meeting
exports.meetingSchema = zod_1.z.object({
  id: zod_1.z.string(),
  is_draft: zod_1.z.boolean(),
  author_id: zod_1.z.string(),
  author: account_short_1.accountShortSchema,
  type: zod_1.z.nativeEnum(lingo2_models_1.MeetingTypeEnum),
  category_id: zod_1.z.number().optional(),
  category: zod_1.z.any(),
  slug: zod_1.z.string(),
  title: zod_1.z.string(),
  tokbox_session: zod_1.z.string().optional(),
  cover_id: zod_1.z.string(),
  cover: (0, hash_1.hashSchema)(image_file_1.imageFileSchema).optional(),
  description: zod_1.z.string(),
  language_id: zod_1.z.number().optional(),
  subject_id: zod_1.z.number(),
  level_id: zod_1.z.number().optional(),
  begin: zod_1.z.nativeEnum(lingo2_models_1.MeetingBeginEnum),
  begin_at: zod_1.z.number(),
  end_at: zod_1.z.number(),
  duration: zod_1.z.number(),
  classroom_id: zod_1.z.string().optional(),
  classroom: classroom_1.classroomSchema,
  created_at: zod_1.z.number(),
  published_at: zod_1.z.number(),
  archived_at: zod_1.z.number(),
  started_at: zod_1.z.number().optional(),
  finished_at: zod_1.z.number().optional(),
  engine: zod_1.z.nativeEnum(lingo2_models_1.MeetingEngineEnum),
  access: zod_1.z.nativeEnum(lingo2_models_1.MeetingAccessEnum),
  charging: zod_1.z.nativeEnum(lingo2_models_1.BillingMeetingChargingEnum),
  options: zod_1.z.object({
    reschedule_begin_at: zod_1.z.number(),
    reschedule_end_at: zod_1.z.number(),
    sequence_number: zod_1.z.number(),
    sequence_total: zod_1.z.number()
  }),
  participants_limit: zod_1.z.number(),
  participants_count: zod_1.z.number(),
  reservations_count: zod_1.z.number(),
  keywords: zod_1.z.array(zod_1.z.string()),
  status: zod_1.z.nativeEnum(lingo2_models_1.MeetingStatusEnum),
  audio_video_state: zod_1.z.boolean().optional(),
  billing_status: zod_1.z.nativeEnum(lingo2_models_1.MeetingBillingStatusEnum),
  session_id: zod_1.z.string().optional(),
  school_id: zod_1.z.string().optional(),
  school: school_short_1.schoolShortSchema.optional(),
  price_tier: zod_1.z.number(),
  participants: zod_1.z.array(meeting_participant_1.meetingParticipantSchema),
  finance_info: zod_1.z.any(),
  homework_due_at: zod_1.z.number(),
  can: zod_1.z.object({
    reschedule: zod_1.z.boolean(),
    autoOpen: zod_1.z.boolean(),
    open: zod_1.z.boolean()
  }),
  is: zod_1.z.object({
    acceptedParticipant: zod_1.z.boolean(),
    owner: zod_1.z.boolean(),
    paidMeeting: zod_1.z.boolean(),
    paidOrFreeParticipant: zod_1.z.boolean(),
    paidAcceptRequired: zod_1.z.boolean(),
    paidJoinRequired: zod_1.z.boolean(),
    author: zod_1.z.boolean(),
    participant: zod_1.z.boolean(),
    guest: zod_1.z.boolean()
  }),
  has: zod_1.z.object({
    meetingGroup: zod_1.z.number(),
    reservationExpireDate: zod_1.z.number()
  }),
  params: zod_1.z.any(),
  stats: zod_1.z.any(),
  user_service_id: zod_1.z.string().optional(),
  user_service: user_service_1.userServiceSchema,
  user_service_contract_id: zod_1.z.string().optional(),
  hidden: zod_1.z.boolean().optional(),
  readonly: zod_1.z.boolean().optional(),
  tenant: zod_1.z.nativeEnum(lingo2_models_1.TenantEnum)
});
